import { NavLink } from "react-router-dom";
import { baseURL,  USER } from "../../../Api/Api";
import Cookie from "cookie-universal"
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { motion } from "motion/react";
import { Container } from "react-bootstrap";
import { WindowSize } from "../../../context/WindowContext";

export default function WelcomeMessage(){

       //cookie
        const cookie = Cookie();
        const token=cookie.get("e-commerce");
        
        //context for size
        const mobSize=useContext( WindowSize);
        const windowSize =mobSize.windowSize;
        //get name for current user
        const [user,setUser]=useState();
        useEffect(()=>{
            if(token){
                axios.get(`${baseURL}/${USER}`,{
                    headers:{
                        Authorization:"Bearer " + token 
                        //useEffect start after end the code
                        //so useEffect can see token ^_^
                    }
                }).then((data)=>setUser(data.data.name))
                .catch((err)=> console.log(err));//if err go to login
            }       
                
            },[]);

    return(
        <div className="web-back-ground d-flex
             align-items-center justify-content-between mb-4"> 
        <Container style={{marginTop:'-400px'}}>    
        <motion.div className="welcome-message"
         style={{width:'400px',textAlign:'center',fontWeight:'bolder'}}
         initial={{ translateY:"200px", opacity: 0 }}
         whileInView={{ translateY:"0px", opacity: 1 }}
         transition={{ duration: 1 }}
         viewport={{once:true}}>
            {token&&user&&<h2 style={{ color:'white',textShadow: '3px 3px #ff914d'}}><span style={{textShadow: '3px 3px #7eed7e'}}>Hi</span>{` ${user}`}</h2>}
            <h4 style={{color:'rgb(5, 5, 112)',marginBottom:'30px'}}>Welcome to our carefully curated collection—premium </h4>
            {/* {!token&&<h4 style={{color:'rgb(5, 5, 112)'}}>
            Discover premium, carefully curated items designed to inspire fun purchases.</h4>} */}
           {!token&& <NavLink className='btn-shop' to='/login'>Shop now</NavLink>}
        </motion.div>
        </Container>
        </div>
        
    )
}